import { useCallback } from 'react';
import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { useFirebase } from '../contexts/FirebaseContext';
import { useAuth } from './useAuth';

export const useDocumentSave = () => {
  const { db, isInitialized, isTerminated } = useFirebase();
  const { currentUser } = useAuth();

  const saveDocument = useCallback(async (type, data, title) => {
    if (!currentUser?.uid || !db || !isInitialized || isTerminated) {
      throw new Error('Cannot save document: not authenticated or database not ready');
    }

    try {
      // Add document to appropriate collection
      const collectionName = type === 'resume' ? 'resumes' : 'coverLetters';
      const docRef = await addDoc(collection(db, collectionName), {
        ...data,
        userId: currentUser.uid,
        title,
        createdAt: Timestamp.now(),
        updatedAt: Timestamp.now()
      });

      // Log activity
      await addDoc(collection(db, 'activities'), {
        userId: currentUser.uid,
        type,
        title: `${type === 'resume' ? 'Resume' : 'Cover Letter'}: ${title}`,
        documentId: docRef.id,
        timestamp: Timestamp.now()
      });

      return docRef.id;
    } catch (error) {
      console.error(`Error saving ${type}:`, error);
      throw error;
    }
  }, [currentUser, db, isInitialized, isTerminated]);

  return { saveDocument };
}; 